import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/psx-frontend/psx-frontend/app/indices/fluctuation/IndexFluctuationClient.tsx");
